import { useSelector } from 'react-redux';

/**
 * Hook to get the conversation of an RCS conversation. Includes the
 * loading/error states
 * @param {(string|null|undefined)} callerID - string value of the caller ID, or null/undefined
 */
export const useSelectedRcsConversation = callerID => {
  const conversation = useSelector(
    state => state?.rcs.conversations?.[callerID],
  );
  return conversation;
};

/**
 * Hook to get all of the RCS sessions. Includes the
 * loading/error states
 */
export const useRcsConversations = () => {
  const conversation = useSelector(state => state?.rcs.conversations);
  return conversation;
};
